/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "./GestionRecruteurCard.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "Components/Modal/Modal";
import { convert } from "Services/functions";
import { BiCheckCircle, BiUser } from "react-icons/bi";
import { RiCloseCircleLine, RiBuildingLine } from "react-icons/ri";
import { FiAward, FiAlertCircle } from "react-icons/fi";
import axios from "axios";
import { updateRequests } from "Redux/Actions/requestsActions";
import { formatPhoneNumber } from "react-phone-number-input";

const GestionRecruteurCard = (props) => {
  let values = {
    ...props.values,
  };

  const [isVisibleDetails, setIsVisibleDetails] = useState(false);

  const manageRequest = (decision) => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/recruiter_membership_requests/${values.id}/${decision}`;
    axios
      .get(url, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then(() => {
        if (decision === "validate") {
          values.validated = 1;
          props.uploadToast.current.show({
            severity: "success",
            summary: "Succès : ",
            detail:
              "La demande d'adhésion de " +
              values.companyName +
              " a bien été validée",
            life: 3000,
          });
        } else {
          values.validated = 0;
          props.cancelToast.current.show({
            severity: "error",
            summary: "Suppression : ",
            detail:
              "La demande d'adhésion de " +
              values.companyName +
              " a bien été refusée",
            life: 3000,
          });
        }
        props.handleFilter();
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div className="member_card_formulaire cardHover">
      <div className="member_card_image">
        <RiBuildingLine></RiBuildingLine>
      </div>
      <div className="member_card_container">
        <div
          className="member_card_container__left"
          onClick={() => {
            setIsVisibleDetails(true);
          }}
        >
          <div className="member_card_container__left__title">
            <h1>{values.companyName}</h1>
          </div>
          <div className="member_card_container__left__informations">
            <div className="member_card_container__left__informations__name">
              <BiUser></BiUser>
              <span>{values.firstname + " " + values.surname}</span>
            </div>
            <div className="member_card_container__left__informations__status">
              <FiAward></FiAward>
              <span>{values.recruiterFunction}</span>
            </div>
            <div className="member_card_container__left__informations__date">
              <FiAlertCircle></FiAlertCircle>
              <span>{convert(values.createdAt)}</span>
            </div>
          </div>
          <div className="member_card_container__left__description">
            <span>{values.companyDescription}</span>
          </div>
        </div>
        <div className="member_card_container__right">
          {values.status === "En attente" && (
            <BiCheckCircle
              className="member_card_container__right__validate"
              onClick={() => {
                manageRequest("validate");
              }}
            ></BiCheckCircle>
          )}
          {values.status === "En attente" && (
            <RiCloseCircleLine
              className="member_card_container__right__refuse"
              onClick={() => {
                manageRequest("refuse");
              }}
            ></RiCloseCircleLine>
          )}
        </div>
      </div>

      {isVisibleDetails && (
        <Modal
          visible={isVisibleDetails}
          setVisible={setIsVisibleDetails}
          header="Détails de la demande d'adhésion"
        >
          <div className="member_card_formulaire_modal">
            <span className="member_title">
              <h1>{values.companyName}</h1>
            </span>
            <div className="member_structure">
              <span>Type de structure:</span>
              <div>{values.companyStructure?.label}</div>
            </div>
            {values.siret && (
              <div className="member_siret">
                <span>Numéro de SIRET:</span>
                <div>{values.siret}</div>
              </div>
            )}
            {values.siren && (
              <div className="member_siret">
                <span>Numéro de SIREN:</span>
                <div>{values.siren}</div>
              </div>
            )}
            {values.duns && (
              <div className="member_siret">
                <span>Numéro DUNS:</span>
                <div>{values.duns}</div>
              </div>
            )}
            {values.rna && (
              <div className="member_siret">
                <span>Numéro RNA:</span>
                <div>{values.rna}</div>
              </div>
            )}
            <div className="member_name">
              <span>{"Demandeur(euse):"}</span>
              <div>{values.firstname + " " + values.surname}</div>
            </div>
            <div className="member_status">
              <span>Fonction:</span>
              <div>{values.recruiterFunction}</div>
            </div>
            <div className="member_mail">
              <span>Adresse mail:</span>
              <div>{values.email}</div>
            </div>
            <div className="member_telephone">
              <span>Numéro de téléphone:</span>
              <div>{formatPhoneNumber(values?.telephone)}</div>
            </div>
            {values.companyDescription && (
              <div className="member_name">
                <span>Description de l&apos;entreprise:</span>
                <div>{values.companyDescription}</div>
              </div>
            )}
            {values.companyUrl && (
              <div className="member_url">
                <span>Site internet de l&apos;entreprise</span>
                <div>{values.companyUrl}</div>
              </div>
            )}
            <div className="member_buttons">
              <button
                className="btn-bleu valider_button"
                onClick={() => {
                  manageRequest("validate");
                  setIsVisibleDetails(false);
                }}
              >
                Valider la demande d&apos;adhésion
              </button>
              <button
                className="btn-blanc refuser_button"
                onClick={() => {
                  manageRequest("refuse");
                  setIsVisibleDetails(false);
                }}
              >
                Refuser la demande d&apos;adhésion
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

GestionRecruteurCard.propTypes = {
  memberData: PropTypes.object,
  onValidation: PropTypes.func,
  values: PropTypes.object,
  handleUpdateRequests: PropTypes.func,
  requests: PropTypes.object,
  uploadToast: PropTypes.any,
  cancelToast: PropTypes.any,
  auth: PropTypes.object,
  handleFilter: PropTypes.func,
};

const mapStateToProps = (state) => ({
  requests: state.requests,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateRequests: (value) => {
    dispatch(updateRequests(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GestionRecruteurCard);
